import { TweenMax } from 'gsap'

export default {
  pageToTop() {
    TweenMax.to(document.querySelectorAll('html, body'), 0.9, {
      scrollTop: 0
    })
  }
}
